export const types = {
    //login
    SEND_LOGIN_FORM_REQUEST: 'auth/SEND_LOGIN_FORM_REQUEST',
    SEND_LOGIN_FORM_SUCCESS: 'auth/SEND_LOGIN_FORM_SUCCESS',
    SEND_LOGIN_FORM_ERROR: 'auth/SEND_LOGIN_FORM_ERROR',
    SEND_LOGIN_OTP_FORM_REQUEST: 'auth/SEND_LOGIN_OTP_FORM_REQUEST',
    SEND_LOGIN_OTP_FORM_SUCCESS: 'auth/SEND_LOGIN_OTP_FORM_SUCCESS',
    SEND_LOGIN_OTP_FORM_ERROR: 'auth/SEND_LOGIN_OTP_FORM_ERROR',

    //other
    RECEIVE_AUTH0_SUCCESS: 'auth/RECEIVE_AUTH0_SUCCESS',
    CLEAR_AUTH_MUTUAL_DATA: 'auth/CLEAR_AUTH_MUTUAL_DATA',
    UPDATE_TOKEN: 'auth/UPDATE_TOKEN',
    CLEAR_SESSION: 'auth/CLEAR_SESSION'
};
